export let routes = [
  {
    path: '/x3-side-card',
    name: 'x3-side-card',
    component: () => import('@x3/js/side/card/card.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-card-price',
    name: 'x3-side-card-price',
    component: () => import('@x3/js/side/card/card-price.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsCard(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-card',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsCardPrice(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-card-price',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
